export default "__VITE_PUBLIC_ASSET__eafd40f7__"